import { FC, useEffect, useState } from 'react';
import { Form, Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import { approvalSelection, createApproval } from '@/common/api/expandStore/approveworkbench';
import { ApprovalType, ApprovalTypeValue, BusinessMode } from '../ts-config';
import { isNotEmpty, refactorSelection } from '@lhb/func';
import styles from './index.module.less';
import V2Form from '@/common/components/Form/V2Form';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';

/**
 * 拓店详情-机会点列表-合同审批（需要一鸣 OA）
 */
const Component: FC<{
  visible: boolean;
  setVisible: (visible: boolean) => void;
  /** 任务ID */
  taskId: number;
  /** 审批主体id（机会点id） */
  id: number;
  /** 提交前详情弹窗中的拓店任务详情 */
  taskDetail?: any;
  /** 业务特有的提交审批参数（对象格式） */
  specialParams?: any;
  /** 提交成功 */
  onComplete?: () => void;
}> = ({
  visible,
  setVisible,
  taskId,
  id,
  taskDetail,
  onComplete,
}) => {
  const [form] = Form.useForm();
  const [selection, setSelection] = useState<{
    /** 一鸣业务模式 */
    businessModelList: any[],
  }>({ businessModelList: [] });

  const [requesting, setRequesting] = useState<boolean>(false);

  useEffect(() => {
    methods.getSelection();
  }, []);

  const methods = useMethods({

    getSelection() {
      approvalSelection({}).then((res: any) => {
        setSelection(val => ({
          ...val,
          businessModelList: Array.isArray(res.businessModelList) ? refactorSelection(res.businessModelList) : [],
        }));
      });
    },

    handleCancel() {
      setVisible(false);
      form.resetFields();
    },
    checkFranchiseeInfo(businessModelId: any) {
      const selectedBusinessModel = selection.businessModelList.find((item: any) => item.value === businessModelId);
      const requireFranchiseeInfo = [2, 3, 4].indexOf(Number(selectedBusinessModel?.value)) > -1;
      const hasFranchiseeInfo = taskDetail?.businessMode === BusinessMode.Franchisee &&
        isNotEmpty(taskDetail?.standardFranchiseeName) &&
        isNotEmpty(taskDetail?.standardFranchiseeUniqueId);

      if (requireFranchiseeInfo && !hasFranchiseeInfo) {
        V2Message.error('请关联加盟商后再发起合同签约');
        return false;
      }
      return true;
    },
    handleOk() {
      form.validateFields().then(async (values: any) => {
        if (!methods.checkFranchiseeInfo(values.businessModelId)) return;
        methods.confirmDialog(values);
      });
    },
    /**
     * @description 确认提交弹框填写后提交事件
     * @param values 确认提交弹框的表单对象
     */
    async confirmDialog(values: any) {
      if (requesting) return;

      setRequesting(true);
      const res = await createApproval({
        standardTaskId: taskId,
        id,
        type: ApprovalType.Contract,
        typeValue: ApprovalTypeValue.Contract,
        businessModelId: values.businessModelId,
        remark: values.remark,
      }).finally(() => {
        setRequesting(false);
        setVisible(false);
      });
      if (res) {
        V2Message.success('提交审批成功');
        methods.handleCancel();
        onComplete?.();
      }
    },
  });

  return (
    <Modal
      title='提交审批'
      open={visible}
      destroyOnClose={true}
      width={336}
      onCancel={methods.handleCancel}
      onOk={methods.handleOk}
      className={styles.createModal}
      confirmLoading={requesting}
    >
      <V2Form form={form}>
        <V2FormSelect
          label='业务模式'
          name='businessModelId'
          options={selection.businessModelList}
          config={{ showSearch: true, filterOption: false }}
          required
        />
        <V2FormTextArea
          label='发起理由'
          name='remark'
          maxLength={500}
          placeholder='请输入发起理由，最多输入500字'
          rules={[{ required: true, message: '请输入发起理由' }]}
          config={{ showCount: true }}
        />
      </V2Form>
    </Modal>
  );
};
export default Component;
